import { render, staticRenderFns } from "./CustomApiBuilder.vue?vue&type=template&id=22aaf19c&"
import script from "./CustomApiBuilder.vue?vue&type=script&lang=js&"
export * from "./CustomApiBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports